module.exports = __webpack_public_path__ + "img/map_bg.1de35503.png";